var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Unidade de Saúde")]),_vm._v(" "),_c('Select',{attrs:{"showOptionEmpty":false,"options":_vm.uors},on:{"input":_vm.update},model:{value:(_vm.uor),callback:function ($$v) {_vm.uor=$$v},expression:"uor"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e09666ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectUOR.vue
// module id = MOpE
// module chunks = 15